function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_232",
  "data-name": "Group 232"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_231",
  "data-name": "Group 231"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  className: "cls-1",
  d: "M105.4,0a21.9,21.9,0,0,0-3.809,43.467v6.172H97.655a3.809,3.809,0,0,0,0,7.617h3.936v3.936a3.809,3.809,0,0,0,7.617,0V57.256h3.936a3.809,3.809,0,0,0,0-7.617h-3.936V43.467A21.9,21.9,0,0,0,105.4,0Zm2.728,41.709a.952.952,0,0,0-.823.943v7.939a.952.952,0,0,0,.952.952h4.888a1.9,1.9,0,0,1,0,3.809h-4.888a.952.952,0,0,0-.952.952v4.888a1.9,1.9,0,0,1-3.809,0V56.3a.952.952,0,0,0-.952-.952H97.655a1.9,1.9,0,0,1,0-3.809h4.888a.952.952,0,0,0,.952-.952V42.652a.952.952,0,0,0-.823-.943,20,20,0,1,1,5.455,0Z",
  transform: "translate(-83.5)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_234",
  "data-name": "Group 234",
  transform: "translate(5.732 5.732)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_233",
  "data-name": "Group 233"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  className: "cls-1",
  d: "M144.668,45a15.964,15.964,0,0,0-9.914,3.412.958.958,0,0,0-.167,1.34.948.948,0,0,0,1.335.168,14.085,14.085,0,0,1,8.747-3.009A14.3,14.3,0,1,1,133.4,52.454a.958.958,0,0,0-.167-1.34.948.948,0,0,0-1.335.168A16.153,16.153,0,1,0,144.668,45Z",
  transform: "translate(-128.5 -45)"
})));

var SvgFemale = function SvgFemale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0416\\u0456\\u043D\\u043E\\u0447\\u0456",
    width: 43.799,
    height: 65,
    viewBox: "0 0 43.799 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFemale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/female.3f45b1c1.svg";
export { ForwardRef as ReactComponent };